module.exports = flarum.core.compat['forum/components/PostStream'];